import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import './App.css';

import Home from './components/Home';
import Register from './components/Register';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Integrations from './components/Integrations';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <header>
          <nav>
            <div className="logo">Threadly</div>
            <div className="nav-links">
              <Link to="/">Home</Link>
              <Link to="/integrations">Integrations</Link>
              <Link to="/register">Register</Link>
              <Link to="/login">Login</Link>
              <Link to="/dashboard">Dashboard</Link>
            </div>
          </nav>
        </header>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
        </main>
        <footer>
          <p>&copy; 2025 Threadly. All rights reserved.</p>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;